<template>
  <div class="simple-logo-view">
    <img
        v-if="computedImageSrc"
        :key="computedImageSrc"
        :src="computedImageSrc"
        :data-requested-src="computedImageSrc"
        @error="handleLogoError"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: "SimpleLogo",
  data () {
    return {
      // Speichert nur konkret fehlgeschlagene URLs, damit spaeter geladene Store-URLs nicht blockiert werden.
      failedLogoUrls: []
    }
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      getCustomerIdentifier: 'getCustomerIdentifier',
      getResourcePath: 'getResourcePath',
      getCustomerId: 'getCustomerId',
      getLogoUrl: 'getLogoUrl'
    }),
    computedImageSrc () {
      const logoUrl = this.normalizeLogoUrl(this.getLogoUrl)

      if (logoUrl && !this.failedLogoUrls.includes(logoUrl)) {
        return logoUrl
      }

      if (!this.getResourcePath || !this.getCustomerId) {
        return ''
      }

      const fallbackUrl = this.getResourcePath+this.getCustomerId+'/logo/logo.svg'

      return this.failedLogoUrls.includes(fallbackUrl) ? '' : fallbackUrl
    }
  },
  methods: {
    normalizeLogoUrl (value) {
      if (!value || value === 'null' || value === 'undefined' || value === 'false') {
        return ''
      }

      return value
    },
    handleLogoError (event) {
      const failedUrl = event && event.target ? event.target.getAttribute('data-requested-src') : this.computedImageSrc

      // Der Fehler kann von einem alten Fallback-Request stammen; deshalb immer die konkrete img-URL merken.
      if (failedUrl && !this.failedLogoUrls.includes(failedUrl)) {
        this.failedLogoUrls.push(failedUrl)
      }
    }
  }
}
</script>

<style scoped>

</style>
